module.exports = __webpack_public_path__ + "img/P39-en.c4f4b68e.png";